import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import type { BooleanFilterState } from '../../../../../common/constants/filters/boolean-filter/types';
import { ProductKeys, type ProductKeys1P } from '../../../../../common/constants/products';
import { getProducts3PFromConfigForFilter } from '../../../../../common/utils/filters';
import { createBooleanFilter } from '../../../../filters/boolean-filter/create-boolean-filter';

const productKeys1P: ProductKeys1P[] = [ProductKeys.Confluence];

const products3PFromConfig: ProductKeys3P[] = getProducts3PFromConfigForFilter('verified');

export const filter: Readonly<{
	id: 'verified';
	type: 'boolean';
	queryParams: {
		key: string;
		getState: (
			queryParams: Record<string, string[]>,
			cloudId: string,
		) => BooleanFilterState<'verified'>;
	};
	products: ProductKeys[];
	universal: boolean;
	customValueFields?: string[];
	withState: (
		state: unknown,
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'verified'>;
	getInitialState: (
		config: import('../../../../../common/constants/filters/cloud-config/types').CloudConfig,
	) => import('../../../../../common/constants/filters/boolean-filter/types').BooleanFilterMonad<'verified'>;
	isCompatible: (filterId?: string) => boolean;
	isSupportCustomValue: boolean;
	isSuggestedFilter?: (primaryProduct?: string) => boolean;
}> = createBooleanFilter({
	id: 'verified',
	queryParams: { key: 'verified' },
	products: [...productKeys1P, ...products3PFromConfig],
	alwaysVisible: true,
	universal: false,
});
